import { render, staticRenderFns } from "./Course-form.vue?vue&type=template&id=3d297be8&scoped=true"
import script from "./Course-form.vue?vue&type=script&lang=js"
export * from "./Course-form.vue?vue&type=script&lang=js"
import style0 from "./Course-form.vue?vue&type=style&index=0&id=3d297be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d297be8",
  null
  
)

export default component.exports